export default "__VITE_ASSET__BTFvaxK2__"